import { HStack, Image, Text } from "@chakra-ui/react";
import {
  facebookIcon,
  instagramIcon,
  linkedInIcon,
  twitterIcon,
} from "assets/images";

const CopyRightText: React.FC = () => {
  return (
    <HStack justifyContent={"space-between"} w={"100%"}>
      <HStack>
        <Image src={facebookIcon} boxSize="14px" objectFit="contain" />
        <Image src={twitterIcon} boxSize="14px" objectFit="contain" />
        <Image src={linkedInIcon} boxSize="14px" objectFit="contain" />
        <Image src={instagramIcon} boxSize="14px" objectFit="contain" />
      </HStack>

      <Text fontSize="xs" color={"secondary.800"}>
        © Copyright 2024 Al Quran AL Kareem
      </Text>
    </HStack>
  );
};

export default CopyRightText;
